interface LatestReadHandlers<TResult> {
  onResult: (result: TResult) => void;
  onError: (error: unknown) => void;
}

/**
 * Reads of which only the latest one applies its outcome: a newer read or a
 * cancel (reset, project change) drops the outcome of the older ones.
 */
export function createLatestRead(): {
  run: <TResult>(read: () => Promise<TResult>, handlers: LatestReadHandlers<TResult>) => Promise<void>;
  cancel: () => void;
} {
  let generation = 0;
  return {
    async run(read, { onResult, onError }) {
      const readGeneration = ++generation;
      try {
        const result = await read();
        if (readGeneration === generation) {
          onResult(result);
        }
      } catch (error) {
        if (readGeneration === generation) {
          onError(error);
        }
      }
    },
    cancel() {
      generation += 1;
    },
  };
}
